module.exports = __webpack_public_path__ + "assets/fonts/arrow-down-1.707169ed.svg";